<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem; display: flex; align-items: flex-start; justify-content: space-between; flex-wrap: wrap; gap: 1rem;">
    <div>
      <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
        Services – Mise en relation
      </h1>
      <p style="font-size: 0.875rem; color: #64748b; margin: 0;">
        Gérer les services publiés par les prestataires
      </p>
    </div>
    <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
      <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data.length }}</span> service(s)
      <app-loading [isVisible]="loading2"></app-loading>
    </div>
  </div>

  <!-- Stats row -->
  <div class="grid grid-cols-2 lg:grid-cols-4" style="gap: 1.25rem; margin-bottom: 1.5rem;">
    <div class="afri-card px-5 py-4">
      <p class="text-xs text-gray-500 mb-1">Total</p>
      <p class="text-2xl font-bold" style="color: #2E3190;">{{ data.length }}</p>
    </div>
    <div class="afri-card px-5 py-4">
      <p class="text-xs text-gray-500 mb-1">Actifs</p>
      <p class="text-2xl font-bold text-emerald-600">{{ activeCount }}</p>
    </div>
    <div class="afri-card px-5 py-4">
      <p class="text-xs text-gray-500 mb-1">Inactifs</p>
      <p class="text-2xl font-bold text-red-500">{{ data.length - activeCount }}</p>
    </div>
    <div class="afri-card px-5 py-4">
      <p class="text-xs text-gray-500 mb-1">Sélectionné</p>
      <p class="text-sm font-semibold text-gray-700 truncate mt-0.5">
        {{ selected_data?.name ?? '—' }}
      </p>
    </div>
  </div>

  <!-- Action bar -->
  <div class="afri-card">
    <div class="afri-card-header gap-2">
      <!-- Search -->
      <div class="relative flex-1 max-w-sm">
        <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
             fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0"/>
        </svg>
        <input type="text" [(ngModel)]="search_text"
               class="afri-input pl-9" placeholder="Rechercher un service...">
      </div>

      <div class="flex items-center gap-2 ml-auto flex-wrap">
        <button (click)="show(showContent)"
                [disabled]="!selected_data"
                class="btn-afri-outline"
                [class.opacity-50]="!selected_data">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
          </svg>
          Détails
        </button>
        <button (click)="delete()"
                [disabled]="!selected_data"
                class="btn-afri-danger"
                [class.opacity-50]="!selected_data">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
          Supprimer
        </button>
        <button (click)="getAll()" class="btn-afri-outline">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
          Actualiser
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="overflow-x-auto">
      <table class="afri-table">
        <thead>
          <tr>
            <th style="width: 48px;">#</th>
            <th>Service</th>
            <th>Prestataire</th>
            <th>Catégorie</th>
            <th>Prix/h</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of data | paginate: {
                id: 'svcP1',
                itemsPerPage: pg.pageSize,
                currentPage: pg.p,
                totalItems: pg.total
              } | sampleSearch:search_text; let i = index"
              [class.ring-2]="selected_data?.id === d.id"
              style="--tw-ring-color: rgba(46,49,144,0.3);"
              class="cursor-pointer"
              (click)="select(d)">

            <td>
              <input type="radio" name="svcRadio"
                     [checked]="selected_data?.id === d.id"
                     (click)="select(d)"
                     class="cursor-pointer"
                     style="accent-color: #2E3190;">
            </td>

            <td>
              <div class="font-medium text-gray-800">{{ d.name }}</div>
              <div class="text-xs text-gray-500 truncate max-w-xs">{{ d.description }}</div>
            </td>

            <td class="text-gray-600">
              {{ d.provider?.user?.lastname ?? d.provider?.name ?? '—' }}
              {{ d.provider?.user?.firstname ?? '' }}
            </td>

            <td>
              <span *ngIf="d.subcategory" class="badge-default">
                {{ d.subcategory?.name ?? d.subcategory }}
              </span>
              <span *ngIf="!d.subcategory" class="text-gray-400 text-xs">—</span>
            </td>

            <td class="font-medium text-gray-800">{{ formatPrice(d.price_per_hour) }}</td>

            <td>
              <span [ngClass]="d.is_active ? 'badge-success' : 'badge-danger'">
                <span class="w-1.5 h-1.5 rounded-full inline-block mr-1"
                      [style.background]="d.is_active ? '#059669' : '#dc2626'"></span>
                {{ d.is_active ? 'Actif' : 'Inactif' }}
              </span>
            </td>

            <td>
              <div class="flex items-center gap-1.5">
                <button (click)="toggleActive(d); $event.stopPropagation()"
                        [class]="d.is_active ? 'btn-afri-danger' : 'btn-afri-success'"
                        class="text-xs px-2.5 py-1.5">
                  {{ d.is_active ? 'Désactiver' : 'Activer' }}
                </button>
                <button (click)="delete(d); $event.stopPropagation()"
                        class="p-1.5 rounded-lg hover:bg-red-50 text-red-400 hover:text-red-600 transition-colors border-0 bg-transparent">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>

          <!-- Empty state -->
          <tr *ngIf="data.length === 0 && !loading2">
            <td colspan="7" class="py-16 text-center">
              <div class="flex flex-col items-center gap-3 text-gray-400">
                <svg class="w-12 h-12 text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
                </svg>
                <p class="font-medium">Aucun service publié</p>
                <p class="text-sm">Les services publiés par les prestataires apparaîtront ici</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="px-6 pb-4">
      <pagination-controls
        id="svcP1"
        (pageChange)="getPage($event)"
        [maxSize]="7"
        [autoHide]="true"
        [responsive]="true"
        [previousLabel]="'Précédent'"
        [nextLabel]="'Suivant'">
      </pagination-controls>
    </div>

  </div>
</div>


<!-- ─── Modal: Détails du service ─────────────────────── -->
<ng-template #showContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title fw-semibold">
      <svg class="w-5 h-5 inline me-2 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
      </svg>
      Détails du service
    </h5>
    <button type="button" class="btn-close" (click)="d('Cross click')"></button>
  </div>

  <div class="modal-body">
    <div class="grid grid-cols-1 gap-4">

      <!-- Service name + status -->
      <div class="flex items-center justify-between rounded-xl p-4"
           style="background: linear-gradient(135deg, #2E3190, #3a3eaa); color: white;">
        <div>
          <p class="text-xs opacity-70 mb-0.5">Service</p>
          <p class="text-lg font-bold">{{ selected_data?.name }}</p>
        </div>
        <span class="px-3 py-1 rounded-full text-sm font-semibold"
              [style.background]="selected_data?.is_active ? '#ecfdf5' : '#fef2f2'"
              [style.color]="selected_data?.is_active ? '#059669' : '#dc2626'">
          {{ selected_data?.is_active ? 'Actif' : 'Inactif' }}
        </span>
      </div>

      <!-- Details grid -->
      <div class="grid grid-cols-2 gap-3">
        <div class="rounded-xl p-4 bg-gray-50">
          <p class="text-xs text-gray-500 mb-1">Prestataire</p>
          <p class="font-semibold text-gray-800">
            {{ selected_data?.provider?.user?.lastname ?? selected_data?.provider?.name ?? '—' }}
            {{ selected_data?.provider?.user?.firstname ?? '' }}
          </p>
        </div>
        <div class="rounded-xl p-4 bg-gray-50">
          <p class="text-xs text-gray-500 mb-1">Prix / heure</p>
          <p class="font-bold text-lg" style="color: #2E3190;">
            {{ formatPrice(selected_data?.price_per_hour) }}
          </p>
        </div>
        <div class="rounded-xl p-4 bg-gray-50">
          <p class="text-xs text-gray-500 mb-1">Sous-catégorie</p>
          <p class="font-semibold text-gray-800">
            {{ selected_data?.subcategory?.name ?? selected_data?.subcategory ?? '—' }}
          </p>
        </div>
        <div class="rounded-xl p-4 bg-gray-50">
          <p class="text-xs text-gray-500 mb-1">Évaluations</p>
          <p class="font-semibold text-gray-800">
            <span *ngIf="selected_data?.reviews_count">
              {{ selected_data.reviews_count }} avis
            </span>
            <span *ngIf="!selected_data?.reviews_count" class="text-gray-400">Aucun avis</span>
          </p>
        </div>
      </div>

      <!-- Description -->
      <div class="rounded-xl p-4 bg-gray-50" *ngIf="selected_data?.description">
        <p class="text-xs text-gray-500 mb-2">Description</p>
        <p class="text-sm text-gray-700 leading-relaxed">{{ selected_data.description }}</p>
      </div>

    </div>
  </div>

  <div class="modal-footer">
    <button type="button" (click)="toggleActive(selected_data); d('toggle')"
            [class]="selected_data?.is_active ? 'btn-afri-danger' : 'btn-afri-success'">
      {{ selected_data?.is_active ? 'Désactiver ce service' : 'Activer ce service' }}
    </button>
    <button type="button" (click)="d('close')" class="btn-afri-outline">Fermer</button>
  </div>
</ng-template>
